import React, { useState } from "react";
import { MoreHorizontal, Settings } from "lucide-react";

// --- Simple inline icon placeholders for brands (colored circles/letters) ---
// You can swap these for real brand SVGs/logos if you have them.
const BrandIcon = ({ bg, children }) => (
  <div
    className="flex items-center justify-center rounded-xl shrink-0"
    style={{ width: 40, height: 40, background: bg }}
  >
    {children}
  </div>
);

const icons = {
  microsoft: (
    <BrandIcon bg="#F3F3F3">
      <svg width="20" height="20" viewBox="0 0 20 20">
        <rect x="1" y="1" width="8.5" height="8.5" fill="#F35325" />
        <rect x="10.5" y="1" width="8.5" height="8.5" fill="#81BC06" />
        <rect x="1" y="10.5" width="8.5" height="8.5" fill="#05A6F0" />
        <rect x="10.5" y="10.5" width="8.5" height="8.5" fill="#FFBA08" />
      </svg>
    </BrandIcon>
  ),
  google: (
    <BrandIcon bg="#F3F3F3">
      <svg width="20" height="20" viewBox="0 0 48 48">
        <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.9 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34.5 6 29.5 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.7-.4-3.5z"/>
        <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.6 16 18.9 13 24 13c3 0 5.8 1.1 7.9 3l5.7-5.7C34.5 6 29.5 4 24 4c-7.4 0-13.8 4.1-17.1 10.1z"/>
        <path fill="#4CAF50" d="M24 44c5.3 0 10.1-1.8 13.9-4.9l-6.4-5.4C29.4 35.6 26.8 36.5 24 36.5c-5.3 0-9.7-3.4-11.3-8.1l-6.6 5.1C9.9 39.6 16.4 44 24 44z"/>
        <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.2-4.2 5.6l6.4 5.4C39.9 37 44 31 44 24c0-1.3-.1-2.7-.4-3.5z"/>
      </svg>
    </BrandIcon>
  ),
  salesforce: (
    <BrandIcon bg="#EAF3FB">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="#00A1E0">
        <path d="M10 5.4c.9-1 2.2-1.6 3.6-1.6 1.9 0 3.5 1.1 4.3 2.8.7-.3 1.5-.5 2.3-.5 2.9 0 5.3 2.4 5.3 5.3s-2.4 5.3-5.3 5.3c-.4 0-.7 0-1-.1-.6 1.2-1.9 2-3.3 2-.6 0-1.2-.1-1.7-.4-.7 1.6-2.3 2.7-4.1 2.7-1.9 0-3.6-1.2-4.2-2.9-.3.1-.6.1-.9.1-2.5 0-4.5-2-4.5-4.5 0-1.6.9-3.1 2.2-3.9-.1-.4-.2-.8-.2-1.2 0-2.5 2-4.5 4.5-4.5.9 0 1.8.3 2.5.8"/>
      </svg>
    </BrandIcon>
  ),
  azure: (
    <BrandIcon bg="#EAF1FC">
      <svg width="20" height="20" viewBox="0 0 24 24">
        <path fill="#0078D4" d="M9.5 3h6.2L9.9 20.1c-.2.5-.6.9-1.2.9H3.4c-.4 0-.7-.4-.5-.8L9.5 3z"/>
        <path fill="#0078D4" opacity="0.8" d="M15.7 3l-4.9 14.3 7.2 3.6c.5.2 1-.2 1-.7L15.7 3z"/>
      </svg>
    </BrandIcon>
  ),
  slack: (
    <BrandIcon bg="#F3F3F3">
      <svg width="20" height="20" viewBox="0 0 122.8 122.8">
        <path fill="#36C5F0" d="M25.8 77.6a12.9 12.9 0 11-12.9-12.9h12.9v12.9z"/>
        <path fill="#36C5F0" d="M32.3 77.6a12.9 12.9 0 0125.8 0v32.3a12.9 12.9 0 01-25.8 0V77.6z"/>
        <path fill="#2EB67D" d="M45.2 25.8A12.9 12.9 0 1158.1 12.9v12.9H45.2z"/>
        <path fill="#2EB67D" d="M45.2 32.3a12.9 12.9 0 010 25.8H12.9a12.9 12.9 0 010-25.8h32.3z"/>
        <path fill="#ECB22E" d="M97 45.2a12.9 12.9 0 1112.9 12.9H97V45.2z"/>
        <path fill="#ECB22E" d="M90.5 45.2a12.9 12.9 0 01-25.8 0V12.9a12.9 12.9 0 0125.8 0v32.3z"/>
        <path fill="#E01E5A" d="M77.6 97a12.9 12.9 0 11-12.9 12.9V97h12.9z"/>
        <path fill="#E01E5A" d="M77.6 90.5a12.9 12.9 0 010-25.8h32.3a12.9 12.9 0 010 25.8H77.6z"/>
      </svg>
    </BrandIcon>
  ),
  dropbox: (
    <BrandIcon bg="#EAF1FC">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="#0061FF">
        <path d="M6 3l6 4-6 4-6-4 6-4zm12 0l6 4-6 4-6-4 6-4zM0 15l6-4 6 4-6 4-6-4zm18-4l6 4-6 4-6-4 6-4zM6 20l6-4 6 4-6 4-6-4z"/>
      </svg>
    </BrandIcon>
  ),
  box: (
    <BrandIcon bg="#EAF1FC">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="#0061D5">
        <circle cx="12" cy="12" r="10" />
      </svg>
    </BrandIcon>
  ),
  zapier: (
    <BrandIcon bg="#FFF1E8">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="#FF4A00">
        <path d="M11 2h2v8.3l7.1-4.1 1 1.7L14 12l7.1 4.1-1 1.7L13 13.7V22h-2v-8.3L3.9 17.8l-1-1.7L10 12 2.9 7.9l1-1.7L11 10.3V2z"/>
      </svg>
    </BrandIcon>
  ),
};

const CONNECTED = [
  {
    key: "microsoft",
    name: "Microsoft 365",
    desc: "Integrate with Word, Excel, PowerPoint and SharePoint.",
  },
  {
    key: "google",
    name: "Google Workspace",
    desc: "Integrate with Drive, Docs, Sheets and Gmail.",
  },
  {
    key: "salesforce",
    name: "Salesforce",
    desc: "Sync users and manage documents within Salesforce.",
  },
  {
    key: "azure",
    name: "Azure AD (Microsoft Entra ID)",
    desc: "SSO and user provisioning with Azure AD.",
  },
];

const AVAILABLE = [
  {
    key: "slack",
    name: "Slack",
    desc: "Receive notifications and actionable messages.",
  },
  {
    key: "dropbox",
    name: "Dropbox",
    desc: "Store and manage documents in Dropbox.",
  },
  {
    key: "box",
    name: "Box",
    desc: "Secure file storage and sharing with Box.",
  },
  {
    key: "zapier",
    name: "Zapier",
    desc: "Automate workflows and connect with 5000+ apps.",
  },
];

const TABS = ["All Integrations", "Connected", "Available"];

function ConnectedRow({ item, onSettings, onMenuToggle, menuOpen, onDisconnect }) {
  return (
    <div className="flex items-center justify-between py-4 border-b border-gray-100 last:border-b-0">
      <div className="flex items-center gap-4 min-w-0">
        {icons[item.key]}
        <div className="min-w-0">
          <p className="text-[16px] font-medium text-gray-900 leading-tight">
            {item.name}
          </p>
          <p className="text-sm text-gray-400 leading-tight mt-0.5 truncate">
            {item.desc}
          </p>
        </div>
      </div>

      <div className="flex items-center gap-3 shrink-0 relative">
        <span className="inline-flex items-center rounded-full bg-emerald-50 text-emerald-600 text-xs font-medium px-3 py-1">
          Connected
        </span>
        <button
          onClick={() => onSettings(item.key)}
          className="w-8 h-8 flex items-center justify-center rounded-lg text-gray-400 hover:bg-gray-50 hover:text-gray-600 transition-colors"
          aria-label={`${item.name} settings`}
        >
          <Settings size={16} />
        </button>
        <button
          onClick={() => onMenuToggle(item.key)}
          className="w-8 h-8 flex items-center justify-center rounded-lg text-gray-400 hover:bg-gray-50 hover:text-gray-600 transition-colors"
          aria-label={`${item.name} more options`}
        >
          <MoreHorizontal size={16} />
        </button>

        {menuOpen === item.key && (
          <div className="absolute right-0 top-10 z-10 w-40 rounded-lg border border-gray-100 bg-white shadow-lg py-1">
            <button
              onClick={() => onDisconnect(item.key)}
              className="w-full text-left px-3 py-2 text-sm text-red-500 hover:bg-gray-50"
            >
              Disconnect
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

function AvailableRow({ item, onConnect }) {
  return (
    <div className="flex items-center justify-between py-4 border-b border-gray-100 last:border-b-0">
      <div className="flex items-center gap-4 min-w-0">
        {icons[item.key]}
        <div className="min-w-0">
          <p className="text-[16px] font-medium text-gray-900 leading-tight">
            {item.name}
          </p>
          <p className="text-sm text-gray-400 leading-tight mt-0.5 truncate">
            {item.desc}
          </p>
        </div>
      </div>

      <button
        onClick={() => onConnect(item.key)}
        className="shrink-0 rounded-full border border-indigo-200 text-indigo-600 text-sm font-medium px-5 py-1.5 hover:bg-indigo-50 transition-colors"
      >
        Connect
      </button>
    </div>
  );
}

export default function IntegrationsPage() {
  const [tab, setTab] = useState("All Integrations");
  const [connected, setConnected] = useState(CONNECTED.map((c) => c.key));
  const [menuOpen, setMenuOpen] = useState(null);
  const [toast, setToast] = useState(null);

  const connectedItems = CONNECTED.filter((c) => connected.includes(c.key));
  const availableItems = [
    ...AVAILABLE,
    ...CONNECTED.filter((c) => !connected.includes(c.key)),
  ].filter((a) => !connected.includes(a.key));

  const showConnected = tab === "All Integrations" || tab === "Connected";
  const showAvailable = tab === "All Integrations" || tab === "Available";

  const notify = (msg) => {
    setToast(msg);
    window.clearTimeout(notify._t);
    notify._t = window.setTimeout(() => setToast(null), 2200);
  };

  const handleConnect = (key) => {
    setConnected((prev) => [...prev, key]);
    const item = AVAILABLE.find((a) => a.key === key) || CONNECTED.find((a) => a.key === key);
    notify(`${item?.name || "Integration"} connected`);
  };

  const handleDisconnect = (key) => {
    setConnected((prev) => prev.filter((k) => k !== key));
    setMenuOpen(null);
    const item = CONNECTED.find((a) => a.key === key);
    notify(`${item?.name || "Integration"} disconnected`);
  };

  const handleSettings = (key) => {
    const item = CONNECTED.find((a) => a.key === key);
    notify(`Opening settings for ${item?.name}`);
  };

  return (
    <div
      className="min-h-full w-full bg-white"
      onClick={() => menuOpen && setMenuOpen(null)}
    >
      <div className="w-full">
        {/* Tabs */}
        <div className="flex items-center gap-8 border-b border-gray-100 mb-6">
          {TABS.map((t) => (
            <button
              key={t}
              onClick={() => setTab(t)}
              className={`relative pb-3 text-sm font-medium transition-colors ${
                tab === t ? "text-indigo-600" : "text-gray-400 hover:text-gray-600"
              }`}
            >
              {t}
              {tab === t && (
                <span className="absolute left-0 right-0 -bottom-px h-0.5 bg-indigo-600 rounded-full" />
              )}
            </button>
          ))}
        </div>

        {/* Connected Integrations */}
        {showConnected && (
          <section className="mb-8">
            <h2 className="text-base font-semibold text-gray-900 mb-2">
              Connected Integrations
            </h2>
            {connectedItems.length === 0 ? (
              <p className="text-sm text-gray-400 py-4">No connected integrations yet.</p>
            ) : (
              <div>
                {connectedItems.map((item) => (
                  <ConnectedRow
                    key={item.key}
                    item={item}
                    onSettings={handleSettings}
                    onMenuToggle={(key) =>
                      setMenuOpen((cur) => (cur === key ? null : key))
                    }
                    menuOpen={menuOpen}
                    onDisconnect={handleDisconnect}
                  />
                ))}
              </div>
            )}
          </section>
        )}

        {/* Available Integrations */}
        {showAvailable && (
          <section>
            <h2 className="text-base font-semibold text-gray-900 mb-2">
              Available Integrations
            </h2>
            {availableItems.length === 0 ? (
              <p className="text-sm text-gray-400 py-4">Everything is connected 🎉</p>
            ) : (
              <div>
                {availableItems.map((item) => (
                  <AvailableRow key={item.key} item={item} onConnect={handleConnect} />
                ))}
              </div>
            )}
          </section>
        )}
      </div>

      {/* Toast */}
      {toast && (
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 bg-gray-900 text-white text-sm px-4 py-2 rounded-lg shadow-lg">
          {toast}
        </div>
      )}
    </div>
  );
}